import { useQueryClient } from '@tanstack/react-query'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { useFetchCustomerDetails } from '@zet/customer'
import { APP_NAME } from '@zet/end-points'
import { getName } from '@zet/utils/stringConversion'

import useBrandStore from '../store/brands'
import { REASON_LIST } from '../utils/constants'

export const useSellBrand = ({
  brandId,
  leadSource,
  customerId,
  isEligibleBrand,
  isOnHold,
  variantId,
  criteria,
  categoryId,
}: {
  brandId: string
  leadSource?: string
  isEligibleBrand?: boolean
  isOnHold?: boolean
  customerId?: string
  variantId?: string
  criteria?: string
  categoryId?: number
}) => {
  const { setLeadId, setLeadSource } = useBrandStore((state) => state)
  const queryClient = useQueryClient()
  const { navigate } = useNavigation()
  const { data: customerData } = useFetchCustomerDetails(customerId)

  const onPress = () => {
    setLeadId(null)
    queryClient.invalidateQueries({
      queryKey: [`globalShareLink-${brandId}`],
    })
    queryClient.invalidateQueries({
      queryKey: [`shareLink-${brandId}`],
    })
    setLeadSource(leadSource ?? 'app')
    navigate('ShareCardLink', {
      brandId: brandId,
      source: 'sellNow',
      customerName: getName(customerData?.fullName),
      customerPhoneNumber: customerData?.phoneNumber,
      customerId,
      isEligibleBrand, //true in case of Eligible and false in case of inEligible
      variantId,
      eventName: 'click_action',
      isDisclaimerVisible: categoryId === 15 && APP_NAME !== MY_TEAMS_ADVISOR,
    })
  }

  const isEligibleForSale =
    !isOnHold &&
    !REASON_LIST.includes(criteria || '') &&
    APP_NAME !== MY_TEAMS_ADVISOR

  return { onPress, isEligibleForSale }
}
